import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const SmallTriangleDown = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      {...rest}
      fill={fill}
    >
      <path fill="none" d="M0 0H16V16H0z" />
      <g>
        <path d="M3 11l4.5-6 4.5 6z" transform="translate(3.337 5.175) translate(-3 -5)" />
      </g>
    </svg>
  );
};

SmallTriangleDown.displayName = 'SmallTriangleDown';
